import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import Button from "@/components/Button";
import { api } from "@/lib/api";

export default function PaymentReturn() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking"); // checking | paid | failed
  const [rideId, setRideId] = useState(null);
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setState("failed"); return; }
    let stop = false;
    const poll = async () => {
      if (stop) return;
      attempts.current += 1;
      try {
        const r = await api(`/payments/checkout/status/${sessionId}`);
        setRideId(r.ride_id);
        if (r.payment_status === "paid") return setState("paid");
        if (r.status === "expired" || attempts.current > 8) return setState("failed");
      } catch {
        if (attempts.current > 8) return setState("failed");
      }
      setTimeout(poll, 1800);
    };
    poll();
    return () => { stop = true; };
  }, [sessionId]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-5">
      <div className="w-full max-w-sm rounded-3xl border border-border bg-card p-8 text-center shadow-card">
        {state === "checking" && (
          <>
            <Loader2 className="mx-auto h-12 w-12 animate-spin text-brand-600" />
            <h1 className="mt-4 text-xl font-extrabold text-foreground">Confirming payment…</h1>
            <p className="mt-1 text-sm text-muted-foreground">Please wait a moment.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 className="mx-auto h-14 w-14 text-success" />
            <h1 className="mt-4 text-xl font-extrabold text-foreground">Payment successful</h1>
            <p className="mt-1 text-sm text-muted-foreground">Thanks for riding with Getaride!</p>
            <Button className="mt-6 w-full" onClick={() => navigate(rideId ? `/ride/${rideId}` : "/")}>Done</Button>
          </>
        )}
        {state === "failed" && (
          <>
            <XCircle className="mx-auto h-14 w-14 text-destructive" />
            <h1 className="mt-4 text-xl font-extrabold text-foreground">Payment not completed</h1>
            <p className="mt-1 text-sm text-muted-foreground">You can try again from your trip.</p>
            <Button className="mt-6 w-full" variant="secondary" onClick={() => navigate(rideId ? `/ride/${rideId}` : "/")}>Back to trip</Button>
          </>
        )}
      </div>
    </div>
  );
}
